import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroBanner from './components/HeroBanner';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="可乐漫画 | 韩漫日漫国漫好看的漫画大全 | 热门漫画免费在线看"
        description="可乐漫画📰按类型精选韩漫、日漫、国漫，好看的漫画大全一网打尽，热门漫画免费在线看，下拉式流畅阅读体验。汇集全网最热门的韩漫、日漫、国漫资源，每日更新，高清画质。"
        keywords="可乐漫画, 韩漫, 日漫, 国漫, 好看的漫画, 漫画大全, 热门漫画, 免费漫画, 漫画推荐, 漫画分类, 全集漫画, 在线阅读"
        canonicalUrl="https://kelecomic.com"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '可乐漫画',
          url: 'https://kelecomic.com',
          description: '可乐漫画——按类型精选韩漫、日漫、国漫，好看的漫画大全一网打尽，热门漫画免费在线看',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://kelecomic.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar transparent />

        <main>
          <HeroBanner />
          <FeaturedComics />
          <CategorySection />
          <LatestUpdates />
          <FAQSection />
        </main>

        <Footer />
      </div>
    </>
  );
}